// Transient notifications. Module-level emitter (ES exports, no window globals):
// call toast('…') from anywhere, <Toasts/> in the app shell renders the stack.
import React, { useEffect, useState } from 'react';

let listener = null;
let nextId = 1;

export function toast(message, kind = 'info') {
	listener?.({ id: nextId++, message, kind });
}

export function Toasts() {
	const [items, setItems] = useState([]);

	useEffect(() => {
		listener = (t) => {
			setItems((cur) => [...cur, t]);
			setTimeout(() => setItems((cur) => cur.filter((x) => x.id !== t.id)), 5000);
		};
		return () => {
			listener = null;
		};
	}, []);

	if (!items.length) return null;
	return (
		<div className='toasts' role='status' aria-live='polite'>
			{items.map((t) => (
				<div key={t.id} className={`toast toast--${t.kind}`}>
					{t.message}
				</div>
			))}
		</div>
	);
}
